export enum EmailNotificationFrequencyOption {
    None = 0,
    Daily = 1,
    Immediate = 2,
}

